<template>
  <v-container fluid grid-list-xl>
    <div>
      <v-layout row wrap justify-end class="mb-2">
        <v-btn color="primary" class="mb-2" @click="searchModal = true"><v-icon left>fa-search</v-icon>Search</v-btn>
        <!-- <v-btn class="mb-2" @click="exportFull">Export</v-btn> -->
      </v-layout>

      <v-data-table
        :headers="columnsDisplayed"
        :items="rows"
        :pagination.sync="pagination"
        :loading="loading"
        :total-items="totalRows"
        :rows-per-page-items="pageCountOptions"
        item-key="id"
        class="elevation-1"
        must-sort
        no-data-text="No data found"
        no-results-text="No results found"
        @update:pagination="search"
      >
        <template slot="headers" slot-scope="props">
          <tr>
            <th
              v-for="(header) in props.headers"
              :key="header.value"
              v-show="header.visible"
              :class="['font-weight-bold text-xs-left column sortable pa-1 ma-0', pagination.descending ? 'desc' : 'asc', header.value === pagination.sortBy ? 'active' : '']"
              @click="changeSort(header.value)"
            >
              {{ header.text }}
              <v-icon small>arrow_upward</v-icon>
            </th>
            <th class="ma-0 pa-0 text-xs-right">
              <v-btn icon flat color="primary" @click="reset">
                <v-icon>fa-refresh</v-icon>
              </v-btn>
            </th>
          </tr>
        </template>

        <template slot="items" slot-scope="props">
          <tr>
            <td
              v-for="(header) in columnsDisplayed"
              :key="header.value"
              v-show="header.visible"
              class="pa-1 ma-0"
              :class="(header.type === 'boolean') ? 'text-xs-center' : ''"
            >
              <template v-if="header.type === 'boolean'">
                <span v-if="props.item[header.value]">Yes</span>
                <span v-else>No</span>
              </template>

              <template v-else-if="header.type === 'money'">
                {{ moneyNoSign(props.item[header.value] / 100) }}
              </template>

              <template v-else-if="header.type === 'date'">
                {{ dateUtc(props.item[header.value]) }}
              </template>

              <template v-else class="text-capitalize">
                {{ props.item[header.value] }}
              </template>
            </td>
            <td class="ma-0 pa-0 text-xs-right">
              <v-btn round small :to="{name: 'Merchant', params: { id: props.item.id }}">View</v-btn>
            </td>
          </tr>
        </template>

        <template slot="no-data">
          No results found
        </template>
      </v-data-table>

    </div>

    <v-dialog v-model="searchModal" @submit.prevent @keydown.esc.prevent="searchModal=false">
      <v-toolbar dense>
        <v-toolbar-title>Search</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn icon flat color="primary" @click.native="searchModal = false">
          <v-icon>fa-close</v-icon>
        </v-btn>
      </v-toolbar>

      <v-card>
        <v-card-text>
          <v-form @keyup.native.enter="searchNew">
            <v-container fluid>
              <v-layout row wrap>
                <v-flex xs12 sm3>
                  <AccountSelect
                    v-model="filter.account_id"
                    multiple
                    label="Account"
                    box
                    hide-details
                    v-if="hasPermission('superuser') || isAccountAdmin() || myProfile.accounts.length > 1"
                  />
                </v-flex>
                <v-flex xs12 sm3>
                  <v-text-field
                    label="Email"
                    v-model="filter.email"
                    box
                    hide-details
                  />
                </v-flex>
                <v-flex xs12 sm3>
                  <v-text-field
                    label="MID"
                    v-model="filter.mid"
                    box
                    hide-details
                  />
                </v-flex>
                <v-flex xs12 sm3>
                  <v-text-field
                    label="Name"
                    v-model="filter.name"
                    box
                    hide-details
                  />
                </v-flex>
              </v-layout>

              <v-layout row wrap>
                <v-flex xs12 sm3>
                  <v-menu
                    ref="createdStartDateModal"
                    :close-on-content-click="false"
                    v-model="createdStartDateModal"
                    :nudge-right="40"
                    :return-value.sync="filter.created_start_date"
                    lazy
                    transition="scale-transition"
                    offset-y
                    full-width
                    min-width="290px"
                  >
                    <v-text-field
                      slot="activator"
                      v-model="formattedCreatedStartDate"
                      label="Created Start"
                      append-icon="event"
                      box
                      hide-details
                    />
                    <v-date-picker
                      v-model="filter.created_start_date"
                      no-title
                      @input="$refs.createdStartDateModal.save(filter.created_start_date)"
                    />
                  </v-menu>
                </v-flex>
                <v-flex xs12 sm3>
                  <v-menu
                    ref="createdEndDateModal"
                    :close-on-content-click="false"
                    v-model="createdEndDateModal"
                    :nudge-right="40"
                    :return-value.sync="filter.created_end_date"
                    lazy
                    transition="scale-transition"
                    offset-y
                    full-width
                    min-width="290px"
                  >
                    <v-text-field
                      slot="activator"
                      v-model="formattedCreatedEndDate"
                      label="Created End"
                      append-icon="event"
                      box
                      hide-details
                    />
                    <v-date-picker
                      v-model="filter.created_end_date"
                      no-title
                      @input="$refs.createdEndDateModal.save(filter.created_end_date)"
                    />
                  </v-menu>
                </v-flex>
                <v-flex xs12 sm3>
                  <v-menu
                    ref="updatedStartDateModal"
                    :close-on-content-click="false"
                    v-model="updatedStartDateModal"
                    :nudge-right="40"
                    :return-value.sync="filter.updated_start_date"
                    lazy
                    transition="scale-transition"
                    offset-y
                    full-width
                    min-width="290px"
                  >
                    <v-text-field
                      slot="activator"
                      v-model="formattedUpdatedStartDate"
                      label="Updated Start"
                      append-icon="event"
                      box
                      hide-details
                    />
                    <v-date-picker
                      v-model="filter.updated_start_date"
                      no-title
                      @input="$refs.updatedStartDateModal.save(filter.updated_start_date)"
                    />
                  </v-menu>
                </v-flex>
                <v-flex xs12 sm3>
                  <v-menu
                    ref="updatedEndDateModal"
                    :close-on-content-click="false"
                    v-model="updatedEndDateModal"
                    :nudge-right="40"
                    :return-value.sync="filter.updated_end_date"
                    lazy
                    transition="scale-transition"
                    offset-y
                    full-width
                    min-width="290px"
                  >
                    <v-text-field
                      slot="activator"
                      v-model="formattedUpdatedEndDate"
                      label="Updated End"
                      append-icon="event"
                      box
                      hide-details
                    />
                    <v-date-picker
                      v-model="filter.updated_end_date"
                      no-title
                      @input="$refs.updatedEndDateModal.save(filter.updated_end_date)"
                    />
                  </v-menu>
                </v-flex>
              </v-layout>

              <v-divider class="primary my-5" />

              <v-layout row wrap justify-end>
                <v-btn color="primary" @click="search">Search</v-btn>
                <v-btn @click="reset">Clear</v-btn>
              </v-layout>
            </v-container>
          </v-form>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import Moment from 'moment'

import Bus from '@/bus'
import ApiMixin from '@/mixins/api'
import AuthMixin from '@/mixins/auth'
import DisplayMixin from '@/mixins/display'
import ExportMixin from '@/mixins/export'
import StoreMixin from '@/store/mixin'

import AccountSelect from '@/components/common/AccountSelect.vue'

export default {
  components: { AccountSelect },

  mixins: [ApiMixin, AuthMixin, DisplayMixin, ExportMixin, StoreMixin],

  data: function () {
    return {
      booleanSelect: [
        {value: '*', text: 'All'},
        {value: '0', text: 'No'},
        {value: '1', text: 'Yes'}
      ],

      columns: [
        {
          value: 'name',
          text: 'Name',
          sortable: true,
          visible: true,
          export: true
        },
        {
          value: 'parent_account_name',
          text: 'Parent Account',
          sortable: true,
          visible: true,
          export: true
        },
        {
          value: 'processor_name',
          text: 'Processor Name',
          sortable: true,
          visible: true,
          export: true
        },
        {
          value: 'is_cashdiscount',
          text: 'Cash Discount',
          sortable: true,
          visible: true,
          export: true,
          type: 'boolean'
        },
        {
          value: 'is_active',
          text: 'Active',
          sortable: true,
          visible: false,
          export: false,
          type: 'boolean'
        },
        {
          value: 'is_testing',
          text: 'Testing',
          sortable: true,
          visible: false,
          export: false,
          type: 'boolean'
        },
        {
          value: 'email',
          text: 'Email',
          sortable: true,
          visible: true,
          export: true
        },
        {
          value: 'contact_name',
          text: 'Contact',
          sortable: true,
          visible: true,
          export: true
        },
        {
          value: 'created',
          text: 'Created',
          sortable: true,
          visible: true,
          export: true,
          type: 'date'
        },
        {
          value: 'updated',
          text: 'Updated',
          sortable: true,
          visible: true,
          export: true,
          type: 'date'
        }
      ],
      pagination: this.defaultPagination(),
      rows: [],
      totalRows: 0,
      pageCountOptions: [5, 10, 25],
      loading: true,

      searchModal: false,
      createdStartDateModal: false,
      createdEndDateModal: false,
      updatedStartDateModal: false,
      updatedEndDateModal: false,

      filter: this.defaultFilter()
    }
  },

  props: {
    userId: Number
  },

  computed: {
    environment () {
      return process.env.NODE_ENV
    },

    columnsDisplayed: function () {
      return this.columns.filter(column => {
        if (this.myProfile.custom && this.myProfile.custom.hasOwnProperty('account_columns')) {
          if (this.myProfile.custom.transaction_columns.includes(column.value)) {
            column.visible = true
          } else {
            column.visible = false
          }
        }

        if (column.visible) {
          return true
        }

        return false
      }, this)
    },

    columnsExported: function () {
      return this.columns.filter(column => {
        if (this.myProfile.custom && this.myProfile.custom.hasOwnProperty('account_export_columns')) {
          if (this.myProfile.custom.transaction_export_columns.includes(column.value)) {
            column.export = true
          } else {
            column.export = false
          }
        }

        if (column.export) {
          return true
        }

        return false
      }, this)
    },

    formattedCreatedStartDate () {
      return this.filter.created_start_date ? Moment(this.filter.created_start_date).format('MMM-DD-YYYY') : ''
    },
    formattedCreatedEndDate () {
      return this.filter.created_end_date ? Moment(this.filter.created_end_date).format('MMM-DD-YYYY') : ''
    },
    formattedUpdatedStartDate () {
      return this.filter.updated_start_date ? Moment(this.filter.updated_start_date).format('MMM-DD-YYYY') : ''
    },
    formattedUpdatedEndDate () {
      return this.filter.updated_end_date ? Moment(this.filter.updated_end_date).format('MMM-DD-YYYY') : ''
    }
  },

  methods: {
    defaultFilter () {
      return {
        name: '',
        email: '',
        mid: '',
        contact_name: '',
        start_date: '',
        end_date: '',
        created_start_date: '',
        created_end_date: '',
        updated_start_date: '',
        updated_end_date: '',
        is_cashdiscount: '*',
        is_active: '*',
        account_id: [],
        user_id: this.userId ? this.userId : '*'
      }
    },

    defaultPagination () {
      return {
        sortBy: this.$store.state.paginationDefaults.sortBy,
        descending: this.$store.state.paginationDefaults.descending,
        rowsPerPage: this.$store.state.paginationDefaults.rowsPerPage,
        page: 1
      }
    },

    searchNew () {
      this.pagination.page = 1
      this.search()
    },

    async search () {
      this.loading = true

      try {
        let filter = { ...this.filter }

        if (!filter.account_id) filter.account_id = '*'

        if (filter.created_start_date) {
          filter.created_start_date = Moment(this.filter.created_start_date).utc().format('YYYY-MM-DD HH:mm:ss')
        }
        if (filter.created_end_date) {
          filter.created_end_date = Moment(Moment(this.filter.created_end_date).format('YYYY-MM-DD') + ' 23:59:59').utc().format('YYYY-MM-DD HH:mm:ss')
        }
        if (filter.updated_start_date) {
          filter.updated_start_date = Moment(this.filter.updated_start_date).utc().format('YYYY-MM-DD HH:mm:ss')
        }
        if (filter.updated_end_date) {
          filter.updated_end_date = Moment(Moment(this.filter.updated_end_date).format('YYYY-MM-DD') + ' 23:59:59').utc().format('YYYY-MM-DD HH:mm:ss')
        }

        let result = await this.api({
          method: 'get',
          url: '/accounts',
          params: {
            filter: filter,
            page: this.pagination.page - 1,
            perPage: this.pagination.rowsPerPage,
            orderBy: this.pagination.sortBy,
            orderDirection: this.pagination.descending ? 'desc' : 'asc'
          }
        })
        this.rows = result.data.rows
        this.totalRows = result.data.count
        this.searchModal = false
      } catch (err) {
        Bus.$emit('openModal', {
          status: 'error',
          message: err
        })
      } finally {
        this.loading = false
      }
    },

    async exportFull () {
      try {
        this.loading = true
        let result = await this.api({
          method: 'get',
          url: '/transactions',
          params: {
            filter: this.filter,
            perPage: '*',
            orderBy: this.pagination.sortBy,
            orderDirection: this.pagination.descending ? 'desc' : 'asc'
          }
        })

        let csvContent = 'data:text/csv;charset=utf-8,'
        let headers = [ ...this.headers ]
        headers.push({
          value: 'customer_po',
          text: 'Customer PO'
        })
        headers.push({
          value: 'custom_field_1',
          text: 'Custom 1'
        })
        headers.push({
          value: 'custom_field_2',
          text: 'Custom 2'
        })
        headers.push({
          value: 'custom_field_3',
          text: 'Custom 3'
        })

        csvContent += [
          headers.map(header => '"' + header.text + '"').join(','),
          ...result.data.rows.map(row => {
            return headers.map(header => {
              let value = row[header.value]
              if (header.value === 'is_recurring') {
                value = (value === 0) ? 'No' : 'Yes'
              }
              if (header.value === 'is_fee_waived') {
                value = (value === 0) ? 'No' : 'Yes'
              }
              if (header.value === 'total_amount') {
                value = '$' + (value / 100).toFixed(2)
              }
              if (value === null) {
                value = ''
              }

              return '"' + ('' + value).replace(/"/, '""') + '"'
            })
              .join(',')
          })

        ]
          .join('\n')

        await this.downloadCSVData(csvContent)

        this.loading = false
      } catch (err) {
        // this.$store.commit('error', err)
        Bus.$emit('openModal', {
          status: 'error',
          message: err
        })
      }
    },

    reset () {
      this.filter = this.defaultFilter()
      this.pagination = this.defaultPagination()

      this.search()
    },

    changeSort (column) {
      if (this.pagination.sortBy === column) {
        this.pagination.descending = !this.pagination.descending
      } else {
        this.pagination.sortBy = column
        this.pagination.descending = false
      }
      this.search()
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/manage/Merchants.vue